// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInResetPasswordFormStyles } from "@conklin/Overrides/Widgets/SignIn/SignInResetPasswordForm";
import { hideElement, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

signInResetPasswordFormStyles.container = {
    gap: 12,
};

signInResetPasswordFormStyles.buttonsGridItem = {
    width: 12,
    css: css`
        justify-content: space-between;
        gap: 10px;
        ${xScreen("lte", "sm")} {
            flex-direction: column-reverse;
        }
    `,
};

signInResetPasswordFormStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

signInResetPasswordFormStyles.sendButton = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

signInResetPasswordFormStyles.reCaptchaGridItem = {
    width: 12,
    css: css`
        &:empty {
            ${hideElement}
        }
    `,
};

signInResetPasswordFormStyles.userNameTextField = {
    css: css`
        max-width: 450px;
        ${xScreen("lte", "md")} {
            max-width: 350px;
        }
        ${xScreen("lte", "sm")} {
            max-width: 100%;
        }
    `,
};

signInResetPasswordFormStyles.descriptionText = {
    css: css`
        line-height: 22px;
    `,
};
